import gql from "graphql-tag";

export const REMOVE_ID_DOCUMENT = gql`
  mutation agentDocuments($id: ID!, $removeFile: Boolean!) {
    agentDocuments(id: $id, removeFile: $removeFile) {
      agentDocument {
        id
      }
    }
  }
`;

export const REMOVE_PROPERTY_PHOTO = gql`
  mutation deletePropertyPhoto($id: ID!, $propertyId: ID!) {
    deletePropertyPhoto(id: $id, propertyId: $propertyId) {
      status
    }
  }
`;
